// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'EditorialNew', 'EditorialNew Fallback'"},"className":"__className_7e00f1","variable":"__variable_7e00f1"};